// extracted by css-extract-rspack-plugin
export default {"supportMessenger":"support-messenger--hZM7clxSyrASrZ_8"};